import toIntegerOrInfinity$1 from './to-integer-or-infinity.js';

var toIntegerOrInfinity = toIntegerOrInfinity$1;
var max = Math.max;
var min = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

export { toAbsoluteIndex as default };
